const types = {
  SET_CLINIC_ID: 'SET_CLINIC_ID',
  SET_ANCHOR_SUBSCRIPTION_KEY: 'SET_ANCHOR_SUBSCRIPTION_INFO',
  SET_CLINIC_TYPE: 'SET_CLINIC_TYPE'
}

const getDefaultState = () => {
  return {
    clinicId: null,
    anchorSubscriptionKey: null,
    isHomeClinic: null,
    isBrainRehabClinic: null,
    isCustomClinic: null,
    onlyUseLatestAddOnList: ['3120947888121710356', '2796273696421971364']
  }
}

// initial state
const state = getDefaultState()

// getters
const getters = {
  clinicId: state => state.clinicId,
  anchorSubscriptionKey: state => state.anchorSubscriptionKey,
  isHomeClinic: state => state.anchorSubscriptionKey.includes('-home'),
  isBrainRehabClinic: state => state.anchorSubscriptionKey.includes('brain-rehab'),
  isCustomClinic: state => state.anchorSubscriptionKey.includes('custom'),
  // showLatestAddOnOnly: state => (state.isHomeClinic || state.isBrainRehabClinic || state.isCustomClinic || (state.onlyUseLatestAddOnList.includes(state.clinicId))),
  onlyUseLatestAddOnList: state => state.onlyUseLatestAddOnList
}

// actions
const actions = {
  setClinicId ({ commit }, payload) {
    commit(types.SET_CLINIC_ID, payload)
  },
  setAnchorSubscriptionKey ({ commit }, payload) {
    commit(types.SET_ANCHOR_SUBSCRIPTION_KEY, payload)
  }
}

// mutations
const mutations = {
  [types.SET_CLINIC_ID] (state, payload) {
    state.clinicId = payload
  },
  [types.SET_ANCHOR_SUBSCRIPTION_KEY] (state, payload) {
    state.anchorSubscriptionKey = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
